export enum CampaignStatusEnum {
  DRAFT = 'draft',
  APPROVE_FOR_PUBLICATION = 'approve_for_publication',
  INTEGRATED = 'integrated',
  PUBLISHED = 'published',
  FINISHED = 'finished',
}
